import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InformationPanelComponent } from './information-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { InformationPanelItemModule } from './components/information-panel-item/information-panel-item.module';

@NgModule({
  declarations: [InformationPanelComponent],
  exports: [InformationPanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    InformationPanelItemModule
  ],
})
export class InformationPanelModule { }
